import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { inputClass } from '../Input/styles';
import { getParent, focusElement } from '../utils/dom/element';
import utils from './utils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';
var target = null;
document.addEventListener('mousedown', function (e) {
  // eslint-disable-next-line prefer-destructuring
  target = e.target;
}, true);
var DefaultValue = {
  value: ''
};

var Text =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Text, _PureComponent);

  var _super = _createSuper2(Text);

  function Text(props) {
    var _this;

    _classCallCheck(this, Text);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleSpanClick = _this.handleSpanClick.bind(_assertThisInitialized(_this));
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Text, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.focus !== this.props.focus && this.props.focus && this.element && (this.props.focusElement === this.element || !this.props.focusElement)) {
        focusElement.end(this.element);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      var onTextSpanRef = this.props.onTextSpanRef;
      this.element = el;
      if (onTextSpanRef) onTextSpanRef(el);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var _this$props = this.props,
          format = _this$props.format,
          index = _this$props.index,
          onChange = _this$props.onChange,
          value = _this$props.value;
      var txt = e.target.innerText;
      if (getParent(target, ".".concat(datepickerClass('picker')))) return;
      if (txt === value) return;

      if (txt.trim().length === 0) {
        onChange(undefined, index, e);
      } else {
        if (typeof format !== 'string') {
          console.error('formatResult should be string when inputable is true');
        }

        var newValue = typeof format === 'string' ? utils.toDateWithFormat(txt, format, undefined, this.getOptions()) : undefined; // if translate fail, clear

        if (!newValue) {
          // @ts-ignore
          this.element.innerText = null;
        }

        onChange(newValue, index, e);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var onTextSpanRef = this.props.onTextSpanRef;
      if (onTextSpanRef) onTextSpanRef(e.target);
    }
  }, {
    key: "handleSpanClick",
    value: function handleSpanClick() {
      var onTextSpanRef = this.props.onTextSpanRef;
      if (onTextSpanRef && this.element) onTextSpanRef(this.element);
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        this.element.blur();
        this.handleBlur(e); // must wait for handleBlur to finish executing

        Promise.resolve().then(function () {
          document.dispatchEvent(new Event('mousedown', {
            bubbles: true
          }));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          inputable = _this$props2.inputable,
          value = _this$props2.value,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          focus = _this$props2.focus;
      var showInput = inputable && !disabled && focus;
      var hideStyle = {
        display: 'none'
      };
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, inputable ?
        /*#__PURE__*/
        React.createElement("span", {
          style: !showInput ? hideStyle : undefined,
          ref: this.bindElement,
          key: "edit",
          contentEditable: inputable,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleInput,
          className: className,
          dangerouslySetInnerHTML: {
            __html: value
          }
        }) : null,
        /*#__PURE__*/
        React.createElement("span", {
          style: showInput ? hideStyle : undefined,
          key: "placeholder",
          onClick: this.handleSpanClick,
          className: classnames(!value && inputClass('placeholder'), className)
        }, value || placeholder))
      );
    }
  }]);

  return Text;
}(PureComponent);

Text.defaultProps = DefaultValue;
export default Text;